const CDN_BASE_URL = 'https://anewgocdn.us/fetch/asset'
const SUPPORTED_OPTION_KEYS = ['w', 'h', 'o']

const buildQueryString = (options = {}) => {
  const params = new URLSearchParams()

  SUPPORTED_OPTION_KEYS.forEach((key) => {
    if (options[key] !== undefined && options[key] !== null) {
      params.set(key, options[key])
    }
  })

  const queryString = params.toString()

  return queryString ? `?${queryString}` : ''
}

export const gcsURL = (folder, file, options) => {
  return `${CDN_BASE_URL}/${folder}/${file}${buildQueryString(options)}`
}
